import { Toaster as Sonner, toast } from "sonner";
import { useTheme } from "./theme";

export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      closeButton
      toastOptions={{ style: { background: "var(--hd-surface)", border: "1px solid var(--hd-border)", color: "var(--hd-fg)", fontSize: 13 } }}
    />
  );
}

export { toast };
